// extracted by mini-css-extract-plugin
var _1 = "SeLwi__menu";
export { _1 as "menu" }
